<bic-popup (close)="close()" [title]="finished ? 'Abgleich abgeschlossen' : 'Mit SharePoint abgleichen'"
           customClass="w-[560px]">
  <div bicPopupContent class="flex flex-col gap-4">
    <span class="text-sm text-gray truncate" [attr.title]="source">{{ source }}</span>

    <!-- Schritt 1: Ordnerstruktur. Gleicher Zeilenaufbau wie im Upload-Popup. -->
    @if (showFolders) {
      <div class="flex flex-col gap-2 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="flex items-center justify-between">
          <span class="text-xs font-medium text-gray-500">
            @if (listing) {
              Änderungen werden aus SharePoint gelesen …
            } @else {
              {{ progress?.foldersDone ?? 0 }}/{{ progress?.foldersTotal ?? 0 }} Ordner angelegt
            }
          </span>
          @if (listing && waitingSeconds > 0) {
            <span class="text-xs text-gray-400">{{ waitingSeconds }} s</span>
          }
        </div>
        <div class="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
          @if (listing) {
            <div class="bg-green-500 h-1.5 w-1/3 rounded-full animate-pulse"></div>
          } @else {
            <div class="bg-green-500 h-1.5 rounded-full transition-all duration-300"
                 [style.width.%]="foldersPending ? folderPercent : 100"></div>
          }
        </div>
        <div class="flex items-center gap-2 text-xs">
          <fa-icon [icon]="faFolder" class="text-gray-400 w-3"></fa-icon>
          <span class="truncate flex-1 text-gray-600">Ordnerstruktur</span>
          @if (foldersPending) {
            <span class="text-gray-400 flex-shrink-0">läuft …</span>
          } @else {
            <fa-icon [icon]="faCircleCheck" class="text-green-500"></fa-icon>
          }
        </div>
      </div>
    }

    <!-- Schritt 2: Dateien. Zählt jede abgearbeitete Datei, auch unveränderte und übersprungene. -->
    <div class="flex flex-col gap-2 p-3 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="flex items-center justify-between">
        <span class="text-xs font-medium text-gray-500">
          @if (listing) {
            Dateien
          } @else {
            {{ filesDone }}/{{ filesTotal }} Dateien abgeglichen
          }
        </span>
        <span class="text-xs text-gray-400">{{ filePercent }}%</span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-1.5">
        <div class="bg-green-500 h-1.5 rounded-full transition-all duration-300" [style.width.%]="filePercent"></div>
      </div>
      @if (listing) {
        <span class="text-xs text-gray-400">Wartet auf die Dateiliste …</span>
      } @else if (finishing) {
        <div class="flex items-center gap-2 text-xs">
          <fa-icon [icon]="faSpinner" class="text-gray-400 w-3 animate-spin"></fa-icon>
          <span class="truncate flex-1 text-gray-600">Wird abgeschlossen …</span>
        </div>
      } @else if (finished) {
        <div class="flex items-center gap-2 text-xs">
          <fa-icon [icon]="faFile" class="text-gray-400 w-3"></fa-icon>
          <span class="truncate flex-1 text-gray-600">{{ summary }}</span>
          @if (failedResult) {
            <fa-icon [icon]="faCircleExclamation" class="text-red-500"></fa-icon>
          } @else {
            <fa-icon [icon]="faCircleCheck" class="text-green-500"></fa-icon>
          }
        </div>
      } @else if (progress?.currentName) {
        <div class="flex items-center gap-2 text-xs">
          <fa-icon [icon]="faFile" class="text-gray-400 w-3"></fa-icon>
          <span class="truncate flex-1 text-gray-600">{{ progress?.currentName }}</span>
          <span class="text-gray-400 flex-shrink-0">wird übernommen …</span>
        </div>
      } @else {
        <span class="text-xs text-gray-400">{{ summary }}</span>
      }
    </div>

    @if (finished && failedResult && result.lastError) {
      <span class="text-sm text-red-500">{{ result.lastError }}</span>
    }
    @if (listing && waitingSeconds >= 30) {
      <span class="text-sm text-gray">
        Der Abgleich ist eingeplant und beginnt, sobald der Server ihn aufgreift.
      </span>
    }
    @if (!finished) {
      <span class="text-sm text-gray">
        Sie können dieses Fenster schließen und weiterarbeiten – der Abgleich läuft auf dem Server weiter, den
        Fortschritt zeigt die Anzeige am rechten Rand.
      </span>
    }
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end gap-4">
    @if (!finished) {
      <bic-button (onClick)="runInBackground()" buttonType="white">
        Im Hintergrund weiterlaufen lassen
      </bic-button>
    }
    <bic-button (onClick)="close()" [disabled]="!finished">Weiter</bic-button>
  </div>
</bic-popup>
